module.exports = "<p>\r\n  vencimientos works!\r\n</p>\r\n"


//////////////////
// WEBPACK FOOTER
// C:/Apache24/htdocs/ostimar/frontend/src/app/components/vencimientos/vencimientos.component.html
// module id = ../../../../../src/app/components/vencimientos/vencimientos.component.html
// module chunks = main